import { render, staticRenderFns } from "./FormularioFallaView.vue?vue&type=template&id=f6affd98&scoped=true"
import script from "./FormularioFallaView.vue?vue&type=script&lang=js"
export * from "./FormularioFallaView.vue?vue&type=script&lang=js"
import style0 from "./FormularioFallaView.vue?vue&type=style&index=0&id=f6affd98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6affd98",
  null
  
)

export default component.exports